import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "modal-wrap default-modal" }
const _hoisted_2 = {
  class: "modal fade",
  id: "phaseTaskPaymentModal",
  tabindex: "-1",
  "aria-labelledby": "addModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = {
  class: "modal-title",
  id: "addModalLabel"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-success text-center mb-4"
}
const _hoisted_10 = {
  key: 2,
  class: "alert alert-danger text-center p-1 mb-3"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_13 = {
  key: 4,
  class: "alert alert-danger text-center p-1 mb-3"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle" }, null, -1)
const _hoisted_16 = { class: "bg-light p-3" }
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = { for: "exampleInputEmail1" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { for: "exampleInputEmail1" }
const _hoisted_21 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_ToDoPhasePaymentHistory = _resolveComponent("ToDoPhasePaymentHistory")
  const _component_Button = _resolveComponent("Button")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("h5", _hoisted_6, _toDisplayString(_ctx.$t('payment_request_details')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hideTaskLogModal && _ctx.hideTaskLogModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_7
              ])
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.error.errorList.createPhase,
                hasError: _ctx.state.ui.error.hasError
              }, null, 8, ["errors", "hasError"]),
              (_ctx.phase.phase)
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_estimated_budget')) + " :", 1),
                    _createTextVNode(" $" + _toDisplayString(_ctx.phase.phase), 1)
                  ]))
                : _createCommentVNode("", true),
              (
                _ctx.role === 1 &&
                _ctx.state.data.paymentHistory.payerPaymentRequests &&
                _ctx.state.data.paymentHistory.payerPaymentRequests.length
              )
                ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentHistory, {
                    key: 1,
                    payerContractor: true,
                    history: _ctx.state.data.paymentHistory.payerPaymentRequests,
                    onClose: _ctx.hideTaskLogModal,
                    onAcknowledgeData: _ctx.acknowledgePayerPayment
                  }, null, 8, ["history", "onClose", "onAcknowledgeData"]))
                : (_openBlock(), _createBlock("div", _hoisted_10, [
                    (_ctx.role === 1)
                      ? (_openBlock(), _createBlock("small", _hoisted_11, [
                          _hoisted_12,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('no_payment_history_yet')) + " !", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])),
              (
                _ctx.role === 4 &&
                _ctx.state.data.paymentHistory.contractorPaymentRequests &&
                _ctx.state.data.paymentHistory.contractorPaymentRequests.length
              )
                ? (_openBlock(), _createBlock(_component_ToDoPhasePaymentHistory, {
                    key: 3,
                    payerContractor: false,
                    history: _ctx.state.data.paymentHistory.contractorPaymentRequests,
                    onClose: _ctx.hideTaskLogModal,
                    onAcknowledgeData: _ctx.acknowledgeContractorPayment
                  }, null, 8, ["history", "onClose", "onAcknowledgeData"]))
                : (_openBlock(), _createBlock("div", _hoisted_13, [
                    (_ctx.role === 4)
                      ? (_openBlock(), _createBlock("small", _hoisted_14, [
                          _hoisted_15,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('no_payment_history_yet')) + " !", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])),
              _createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('amount')), 1),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "exampleamount",
                    "aria-describedby": "emailHelp",
                    placeholder: "Eg. $500",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.paymentRequest.amount = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.paymentRequest.amount]
                  ])
                ]),
                _createVNode("div", _hoisted_19, [
                  _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('remarks')), 1),
                  _withDirectives(_createVNode("input", {
                    type: "email",
                    class: "form-control",
                    id: "exampleDetails",
                    "aria-describedby": "emailHelp",
                    placeholder: "Add details.",
                    rows: "5",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.paymentRequest.detail = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.state.data.paymentRequest.detail]
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode(_component_Button, {
                buttonName: _ctx.state.data.buttonName,
                buttonLoading: _ctx.state.ui.isPostLoading.createPhase,
                onButtonTrigger: _ctx.paymentRequestByPhase
              }, null, 8, ["buttonName", "buttonLoading", "onButtonTrigger"]),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.hideTaskLogModal && _ctx.hideTaskLogModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 0,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true)
  ], 64))
}